export default __webpack_public_path__ + "static/media/interleave.b40caf6c.png";